import {
  Container,
  FieldsWrapper,
  LeftBottom,
  LeftCenter,
  LeftTop,
  RegisterWrapper,
  RepfyLogo,
  RightBottom,
  RightTop,
} from './_loadingScreen';

import { Spinner } from 'shared/components/atoms/Spinner/Spinner';

export const LoadingScreen: React.FC = () => {
  return (
    <Container>
      <LeftTop />

      <LeftCenter />

      <LeftBottom />

      <RegisterWrapper>
        <RepfyLogo />

        <h1>Prestadores</h1>

        <FieldsWrapper>
          <div className="fields-wrapper__info">
            <div className="fields-wrapper__info__call">
              Carregando <br /> <br />
              <Spinner />
            </div>
          </div>
        </FieldsWrapper>
      </RegisterWrapper>
      <RightTop />

      <RightBottom />
    </Container>
  );
};
